import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import { type FloatingBoxType } from '@/defs/floating'

export type ModalType = {
  id: string
} & FloatingBoxType

type ModalStateType = {
  stack: ModalType[]
}

const initialState: ModalStateType = {
  stack: [],
}

export const modalSlice = createSlice({
  initialState,
  name: 'modal',
  reducers: {
    close: (s, { payload }: PayloadAction<string>) => {
      const next = s.stack.filter((modal) => modal.id !== payload)
      if (next.length !== s.stack.length) s.stack = next
    },
    closeAll: (s) => {
      if (s.stack.length) s.stack = initialState.stack
    },
    open: (s, { payload }: PayloadAction<ModalType>) => {
      if (s.stack.some((modal) => modal.id === payload.id)) return
      s.stack.push(payload)
    },
  },
})

export const modalActions = modalSlice.actions
export const modalReducer = modalSlice.reducer
